import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAeAEBALE0EOL09-DsxKzvjOI0Gec0ylbY",
  authDomain: "matam-orders.firebaseapp.com",
  databaseURL: "https://matam-orders-default-rtdb.firebaseio.com",
  projectId: "matam-orders",
  storageBucket: "matam-orders.firebasestorage.app",
  messagingSenderId: "738775253503",
  appId: "1:738775253503:web:9f49f63616d984f79e27ca",
  measurementId: "G-B7CP35H2M6",
};

const app = initializeApp(firebaseConfig);
export const firestoreDb = getFirestore(app);
